import { useState, type FormEvent } from "react";
import { useSearchParams, Link, useNavigate } from "react-router-dom";
import { authApi } from "../api.js";
import { AuthLayout, Button, ErrorBanner, Field, TextInput } from "../components/ui.js";

export function VerifyEmailPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const email = params.get("email") ?? "";
  const [token, setToken] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError(null);
    setBusy(true);
    const res = await authApi.verifyEmail(email, token);
    setBusy(false);
    if (!res.ok) {
      setError(res.error?.errorCode ?? "Verification failed");
      return;
    }
    setDone(true);
    setTimeout(() => navigate("/login"), 1500);
  };

  if (done) {
    return (
      <AuthLayout eyebrow="Account verified" title="Your secure workspace is ready." description="You can now sign in and start organising your portfolio.">
        <div className="auth-card-heading">
          <p className="eyebrow">Complete</p>
          <h2>Email verified</h2>
          <p>Your email is verified. Taking you to login…</p>
        </div>
        <div className="spinner"><span className="spinner-ring" aria-hidden="true" />Redirecting…</div>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout
      eyebrow="One final step"
      title="Verify your email to protect your Nettstay account."
      description="Verification keeps your portfolio and financial information connected to the right person."
    >
      <div className="auth-card-heading">
        <p className="eyebrow">Email verification</p>
        <h2>Check your verification details</h2>
        <p>Enter the token provided by the supported verification flow.</p>
      </div>
      <form onSubmit={onSubmit} className="form-stack">
        {error && <ErrorBanner message={error} />}
        <Field label="Email address">
          <TextInput type="email" required value={email} readOnly />
        </Field>
        <Field label="Verification token">
          <TextInput required value={token} onChange={(e) => setToken(e.target.value)} autoComplete="one-time-code" placeholder="Enter verification token" />
        </Field>
        <Button type="submit" disabled={busy} className="btn-block">{busy ? "Verifying…" : "Verify email"}</Button>
        <p className="form-hint form-hint-centered"><Link to="/login">Back to login</Link></p>
      </form>
    </AuthLayout>
  );
}
